"use client";

// The field context of `FormControl`, apart from it so `Label` (also used outside forms, e.g. in the
// site footer) doesn't load react-hook-form.
import type React from "react";
import { createContext, useContext } from "react";
import type { ControllerFieldState, UseFormRegisterReturn } from "react-hook-form";
import type { InputProps } from "src/components/form/InputTypes";

export type FormControlInfo = {
  id: string;
  name: string;
  disabled: boolean | undefined;
  error: string | undefined;
  label: React.ReactNode | undefined;
  required: boolean | undefined;
  inputProps: Partial<UseFormRegisterReturn> &
    InputProps & {
      name: string;
      id: string;
      label?: React.ReactNode;
    };
  getState: () => ControllerFieldState | undefined;
  invalid: boolean;
  displayInvalid: boolean;
};

export const FormControlContext = createContext<FormControlInfo | undefined>(undefined);

export const useFormControl = () => useContext(FormControlContext);
